module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("\n    Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/RUTH_genpref"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/RUTH_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/RUTH_abbrev"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/RUTH_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Part 1:")])]), _vm._v(" "), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("The tears")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch01#sigil_toc_id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Going away (1:1–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch02#sigil_toc_id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Coming home (1:8–22)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Part 2:")])]), _vm._v(" "), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("The wings of refuge")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch03#sigil_toc_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Grace and gratitude (2:1–13)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch04#sigil_toc_id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A place in the family (2:14–23)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Part 3:")])]), _vm._v(" "), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("The kinsman-redeemer")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch05#sigil_toc_id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The levir and the goel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch06#sigil_toc_id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Faith active in love (3:1–18)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Part 4:")])]), _vm._v(" "), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("The redemption and the joy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch07#sigil_toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Love beyond law (4:1–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch08#sigil_toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. We have a history (4:13–22)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Lord be with you’")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_OT",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: Old Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RUTH_NT",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: New Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56905192","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/RUTH_contents.vue
// module id = 66
// module chunks = 0